import { BuyVipDialog } from "@/components/Vip";
import styles from "./index.module.less";
export default function RiskWarn() {
  const open = () => {
    BuyVipDialog.open({
      isUpgrade: true,
    });
  };
  return (
    <div className={styles.content}>
      系统检测当前填写的授权主体为企业/公司；您当前会员权益为个人，授权主体只能填写个人才能生效，如您需要商用授权给企业，
      <span className={styles.upgradation} onClick={open}>
        请购买/升级企业 VIP
      </span>
    </div>
  );
}
